module.exports = __webpack_public_path__ + "a2e90b3362581afe0c477990f4b2ab74.svg";